var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 12.5L9.99935 9.16663M9.99935 9.16663L13.3327 12.5M9.99935 9.16663V16.6666M16.666 13.119C17.6839 12.2783 18.3327 11.0066 18.3327 9.58329C18.3327 7.05199 16.2807 4.99996 13.7493 4.99996C13.5673 4.99996 13.3969 4.90496 13.3044 4.74807C12.2177 2.90399 10.2114 1.66663 7.91602 1.66663C4.46424 1.66663 1.66602 4.46485 1.66602 7.91663C1.66602 9.63838 2.36222 11.1975 3.48847 12.3279",
    stroke: "#CDD5DF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud02);
export default __webpack_public_path__ + "static/media/upload-cloud-02.60256d7fefbfcb65d2d143a33f881ca8.svg";
export { ForwardRef as ReactComponent };